import { render, staticRenderFns } from "./ServerFilterDeleteProfilesDialog.vue?vue&type=template&id=461b1d68&"
import script from "./ServerFilterDeleteProfilesDialog.vue?vue&type=script&lang=js&"
export * from "./ServerFilterDeleteProfilesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QTable,QTr,QTh,QTd,QBtn,QTooltip,QSeparator,QCardActions,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QIcon,QTable,QTr,QTh,QTd,QBtn,QTooltip,QSeparator,QCardActions,QInnerLoading,QSpinnerGears}, component.options.components || {})
